<script setup>
import { DialogClose, useForwardProps } from "reka-ui";

const props = defineProps({
  asChild: { type: Boolean, default: false },
  as: { type: [String, Object], default: "button" },
});

const forwarded = useForwardProps(props);
</script>

<template>
  <DialogClose v-bind="forwarded">
    <slot />
  </DialogClose>
</template>
